import React from "react";
import Layer from "./Layer";
import SpecialPositionTile from "./SpecialPositionTile";

class Board extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {

        let boardClasses = "board";

        // if (!this.props.accessCookie("initialize")) {
        //     boardClasses = "board display-none";
        // }

        return (
            <div id="board" className={boardClasses}>
                <SpecialPositionTile tile={this.props.board.layer5.left[0]} row="left" specialPosition="special-position-left" clicker={this.props.clicker} graphics={this.props.graphics} />
                <Layer layerItems={this.props.board.layer1} layerNumber="layer1" clicker={this.props.clicker} graphics={this.props.graphics} />
                <SpecialPositionTile tile={this.props.board.layer5.right1[0]} row="right1" specialPosition="special-position-right1" clicker={this.props.clicker} graphics={this.props.graphics} />
                <SpecialPositionTile tile={this.props.board.layer5.right2[0]} row="right2" specialPosition="special-position-right2" clicker={this.props.clicker} graphics={this.props.graphics} />
                <Layer layerItems={this.props.board.layer2} layerNumber="layer2" clicker={this.props.clicker} graphics={this.props.graphics} />
                <Layer layerItems={this.props.board.layer3} layerNumber="layer3" clicker={this.props.clicker} graphics={this.props.graphics} />
                <Layer layerItems={this.props.board.layer4} layerNumber="layer4" clicker={this.props.clicker} graphics={this.props.graphics} />
                <SpecialPositionTile tile={this.props.board.layer5.top[0]} row="top" specialPosition="special-position-top" clicker={this.props.clicker} graphics={this.props.graphics} />
            </div>
        );
    }
}

export default Board;